import React from "react";
import cs from "classnames";

import {
  EntityType,
  Subscription,
} from "../../../../api/grpc/subscription/subscription";
import {
  StatusInformationKeys,
  SubscriptionStatus,
} from "../../../Subscription/SubscriptionStatus/SubscriptionStatus";
import { DetailsData } from "./SubscriptionItems";

import "./SubscriptionRow.scss";

interface Props {
  data?: Subscription;
  hasManagedPartner: boolean;
}

export const SubscriptionPlan = ({ data, hasManagedPartner }: Props) => {
  const status = data?.status.toLowerCase() || "";
  const definedStatus = [
    "cancelled",
    "active",
    "in_trial",
    "non_renewing",
  ].includes(status);
  const isEnding = status === "cancelled" || status === "non_renewing";

  const hasTotalCareSupport = !!data?.addons?.some(
    (addon) => addon.entityType === EntityType.TOTAL_CARE_SUPPORT
  );

  const details: DetailsData[] = [
    {
      title: "Current plan",
      content: data?.name || "",
      className: "SubscriptionRow__value--plan",
    },
    {
      title: "Period",
      content: data?.name.includes("1-Year") ? "1 Year" : "3 Years",
    },
    ...(definedStatus
      ? [
          {
            title: isEnding ? "Expires" : "Renews",
            content: (isEnding ? data?.cancelDate : data?.nextRenewal) || "",
          },
        ]
      : []),
    {
      title: "Support level",
      content: hasTotalCareSupport ? "Total Care Support" : "Standard Support",
    },
  ];

  return (
    <div className="SubscriptionRow SubscriptionRow--plan">
      <dl className="SubscriptionRow__details">
        {details.map((item: DetailsData) => (
          <div key={item.title}>
            <dt className="SubscriptionRow__label">{item.title}</dt>
            <dd className={cs("SubscriptionRow__value", item.className)}>
              {item.content}
            </dd>
          </div>
        ))}
      </dl>
      <div className="SubscriptionRow__actions flex-a-center gap-1">
        <SubscriptionStatus
          status={status as StatusInformationKeys}
          className={`SubscriptionRow__status SubscriptionRow__status--${status}`}
        />
        {!hasManagedPartner && (
          <a
            href="https://gogetcorp.com/pricing/"
            className="SubscriptionRow__compare"
            target="_blank"
            rel="noopener noreferrer"
          >
            Compare plans
          </a>
        )}
      </div>
    </div>
  );
};
